import _ from 'underscore';

export default class OfferConnections {
  constructor($scope, $rootScope, $q, OfferService, OfferCampaignService) {
    $scope.tabs = [{}, {}];
    $scope.times = [];

    $scope.load_offers = function() {
      $scope.loading = true;
      OfferService.get_connections(window.offer.id).then(function(data) {
        $scope.general_count = _.where(data.offers, {
          buyer_id: null
        }).length;
        $scope.personalized_count = data.offers.length - $scope.general_count;
        $scope.offers = data.offers;
        $scope.loading = false;
      });
    };

    $scope.filter_offers = function(offer) {
      if (!$scope.offer.parent_offer_id) {
        return $scope.selected_tab === 0 ? offer.buyer_id === null : offer.buyer_id !== null;
      } else {
        return true;
      }
    };

    $scope.delete_offer = function(offer) {
      if (confirm('Are you sure you want to delete this offer?')) {
        offer.deleting = true;
        OfferService.delete(offer.id).success(function(data) {
          if (data.success) {
            offer.deleting = false;
            $scope.offers.splice(_.indexOf($scope.offers, offer), 1);
          }
        });
      }
    };

    $scope.update_stocklists = function() { 
      var offers = _.filter($scope.offers, function(o) {
        if ($scope.selected_tab === 0) {
          return o.buyer_id === null;
        } else {
          return o.buyer_id !== null;
        }
      });
      if (offers.length > 0) {
        $scope.updating_stocklists = true;
        $rootScope.$broadcast('show_mass_update_dialog', {
          offers: offers
        });
        
        $scope.updating_stocklists = false;
      }
    };

    $scope.check_offers = function() {
      _.each($scope.offers, function(o) {
        if ($scope.selected_tab === 0 && o.buyer_id === null) {
          o.checked = $scope.tabs[0].select_all;
        } else if ($scope.selected_tab === 1 && o.buyer_id !== null) {
          o.checked = $scope.tabs[1].select_all;
        }
      });
    };

    $scope.create_offer_campaigns = function(send) {
      $scope.times = [];
      var offers = _.where($scope.offers, {
        checked: true
      });
      if (offers.length === 0) {
        alert('Please select at least one offer!');
        return false;
      }

      var campaigns = [];

      offers.reduce(function(promise, offer, index) {
        var t0 = performance.now();
        return promise.then(function(result) {
          if (result) {
            campaigns.push(result.campaign_id);
          }

          var deferred = $q.defer();

          var settings = offer.offer_campaign_settings || $scope.offer.offer_campaign_settings;

          var data = {
            offer_id: offer.id,
            campaign_settings: settings,
            deferred: deferred,
            total_count: offers.length,
            current_index: index
          };
          $rootScope.$broadcast('show_create_campaign', data);
          
          var t1 = performance.now();
          $scope.times.push((t1 - t0)/1000);
          return deferred.promise;
        });
      }, $q.when())
        .then(function(result) {
          campaigns.push(result.campaign_id);
          
          if (send) {
            $scope.filter  = {
              offer_campaign_id: campaigns
            };
            OfferCampaignService.get($scope.filter).success(function(data) {
              $rootScope.$broadcast('show_mass_send_dialog', {
                created_times:  $scope.times,
                campaigns: data.campaigns
              });
            });
          } else {
            OfferCampaignService.send_created_campaigns_email(campaigns, $scope.times);
          }
        });
    };

    $scope.mass_check_campaigns = function(index) {
      
      if (index === null) {
        $scope.mass_check_offers = _.filter($scope.offers, function(offer) {
          return offer.checked && offer.offer_campaign_settings;
        });
        if ($scope.mass_check_offers.length > 0) {
          $scope.mass_check_campaigns(0);
        }
      } else {
        var offer = $scope.mass_check_offers[index];
        var campaign_settings = offer.offer_campaign_settings;
        var filter = campaign_settings.filter;
        filter.min_quality_accuracy = filter.pre_min_quality_accuracy;
        filter.min_specs_accuracy = filter.pre_min_specs_accuracy;
        offer.checking_campaigns = true;
        OfferService.find_campaign_recipients(offer.id, filter).success(function(data) {
          offer.recipients_count = data.recipients.general.length + data.recipients.special.length;
          offer.restricted_count = data.recipients.restricted.length;
          offer.checking_campaigns = false;
          if (index < $scope.mass_check_offers.length - 1) {
            $scope.mass_check_campaigns(index + 1);
          }
        });
      }
    };

    $scope.$on('update_offer_data', function(event, data) {
      var offer = _.find($scope.offers, {
        id: data.offer_id
      });
      offer.created_campaign_id = data.campaign_id;
    });

    $scope.init = function() {
      $scope.offer = window.offer;
      $scope.selected_tab = 0;
      $scope.filter = {
        offer_id: window.offer ? window.offer.id : null
      };
      $scope.load_offers();
    };

    $scope.init();
  }
}

OfferConnections.$inject = ['$scope', '$rootScope', '$q', 'OfferService', 'OfferCampaignService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offer-connections.ctrl.js